var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    topStories
  } = options;

__p+='\n\n';
 for(var i = 0; i < topStories.length; i++) { var article = topStories[i]; 
__p+='\n<div class="article-card-container article-card-container-vidora col-xs-12 col-sm-6 col-md-4" data-capi-id="'+
((__t=( article.id ))==null?'':__t)+
'" origin-id="'+
((__t=(article.originId))==null?'':__t)+
'">\n  <div class="article-card">\n    <div class="article-card-header">\n      ';
 if (article.meta.subject) { 
__p+='\n      <a data-omtag="web:article:top-stories:article" href="'+
((__t=( article.webLink ))==null?'':__t)+
'">\n      <span class="news-category" data-category="'+
((__t=( MOVE.ARTICLE.Helper.slugify(article.meta.subject) ))==null?'':__t)+
'"> '+
((__t=( article.meta.subject ))==null?'':__t)+
'</span>\n      </a>\n      ';
 } else { 
__p+='\n      <a data-omtag="web:article:top-stories:article" href="'+
((__t=( article.webLink ))==null?'':__t)+
'">\n        <span class="news-category" data-category="'+
((__t=( MOVE.ARTICLE.Helper.slugify(article.meta.section) ))==null?'':__t)+
'"> '+
((__t=( article.meta.section ))==null?'':__t)+
'</span>\n      </a>\n      ';
 } 
__p+='\n    </div>\n    <div class="article-card-title-container">\n      <a class="article-card-title" data-omtag="web:article:top-stories:article" href="'+
((__t=( article.webLink ))==null?'':__t)+
'">\n        '+
((__t=( article.title ))==null?'':__t)+
'\n      </a>\n    </div> <!-- article-card-title -->\n    <div class="pos-relative">\n      <a href="'+
((__t=( article.webLink ))==null?'':__t)+
'" data-omtag="web:article:top-stories:article">\n        <img class="article-card-image" alt="'+
((__t=( article.title ))==null?'':__t)+
'" src="'+
((__t=( article.images[0].image320Url+"&interlace=true" ))==null?'':__t)+
'" data-pin-nopin="true" />\n      </a>\n    </div> <!-- pos-relative -->\n  </div> <!-- article-card -->\n</div> <!-- col-xs-12 -->\n';

}

__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/news_advice_top_stories_vidora.jst.ejs